// extracted by mini-css-extract-plugin
module.exports = {"SearchP":"SearchP_SearchP__1k7uc","Container":"SearchP_Container__3MHyO","OnlyBigScreen":"SearchP_OnlyBigScreen__3hhz9","SearchSpinners":"SearchP_SearchSpinners__3PLwV"};